import { ChangeEventHandler } from 'react';
import classNames from 'classnames/bind';

import { FormError } from 'containers/forms/FormError';

import s from './Check.module.scss';

const c = classNames.bind(s);

export type TCheckProps = {
  label: string | React.ReactElement;
  name: string;
  id?: string;
  className?: string;
  value: string | number;
  checked?: boolean;
  required?: boolean;
  defaultChecked?: boolean;
  disabled?: boolean;
  inputType?: 'checkbox' | 'radio';
  onChange?: ChangeEventHandler<HTMLInputElement>;
};

export const Check = ({
  label,
  name,
  id,
  value,
  checked,
  defaultChecked,
  disabled,
  className,
  inputType = 'checkbox',
  onChange = () => null,
  ...props
}: TCheckProps) => {
  return (
    <>
      <label className={c(s.check, inputType, className, { disabled })}>
        <input
          className={s.check__input}
          type={inputType}
          name={name}
          value={value}
          id={id}
          defaultChecked={defaultChecked}
          checked={checked}
          tabIndex={0}
          disabled={disabled}
          onChange={onChange}
          {...props}
        />
        <span className={s.check__labelText}>{label}</span>
        {inputType === 'checkbox' && (
          <svg className={s.check__check} width="9.5" height="7.5">
            <path d="M8.8.8l-5.5 6L.8 4" />
          </svg>
        )}
      </label>
      {name && (
        <FormError
          name={name}
          placeholder={typeof label === 'string' ? label : 'undefined'}
        />
      )}
    </>
  );
};
